import { Avatar, Box, Typography } from "@mui/material";
import React, { Fragment } from "react";
import CoverSheetTickIco from "../../../../assets/icons/CoverSheetTickIco";
import ReferenceBackgroundImage from "../../../../assets/images/ReferenceBackgroundImage.svg";
import CommonButton from "../../../../component/Button";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomizeSpan } from "../../../jobs/style";
import { GetWhiteLabelAvatar } from "../../../common-components/CoverSheetFunction";
import { platformWhiteLogo } from "../../../../utils/logo";

export default function Application({
  lg,
  isLoading,
  handleViewJobDescription,
  handleApply,
  handleNotInterested,
  coverSheet,
}) {
  const headerData = [
    {
      name: "Company",
      content: coverSheet?.client_name || " - ",
    },
    { name: "Location", content: coverSheet?.location || " - " },
    { name: "Employment Type", content: coverSheet?.employment || " - " },
  ];
  return (
    <CustomDiv
      sx={{
        backgroundImage: `url(${ReferenceBackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        ...(coverSheet?.submitted && {
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        }),
      }}
      boxShadow="1px 1px 5px 3px rgb(16 24 40 / 13%)"
      padding={lg ? "2rem" : "1rem"}
    >
      {isLoading.loading ? (
        <HandleSkeletion
          height={50}
          width={lg ? "150px" : "60px"}
          transform={"scale(1)"}
        />
      ):(
      <Fragment>
        {coverSheet?.organization?.org_label || typeof coverSheet?.organization?.org_logo_url === "string" ? (
          GetWhiteLabelAvatar(coverSheet?.organization?.org_logo_url, coverSheet?.organization?.org_label,lg,"#fff")
        ) : (
          // <SliderTalairoIco width={lg ? "160px" : "130px"} height={"55px"} />
          platformWhiteLogo({width: lg ? "160px" : "130px", height: "55px"})
        )}
      </Fragment>
      )}

      <CommonGrid2
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        color={"#fff"}
        textAlign={"center"}
        margin={lg ? "2rem 0px 2rem" : "2rem 0px 1rem"}
        alignItems={"center"}
        gap={"1rem"}
        height={"100%"}
      >
        <Typography
          variant={lg ? "h2" : "h2xs"}
          color="#D5DADD"
          textAlign={"center"}
          marginTop={"4px"}
          fontWeight={500}
        >
          Job Title
        </Typography>
        {isLoading.loading ? (
          <HandleSkeletion
            height={50}
            width={lg ? "400px" : "100%"}
            background="rgb(255 255 255 / 33%)"
            margin={"10px auto 0px"}
            transform={"scale(1)"}
          />
        ) : (
          <Typography
            variant={lg ? "h1" : "h2"}
            fontSize={lg && "50px"}
            color="#FFFFFF"
            marginTop={"-5px"}
            fontWeight={700}
            textTransform={"capitalize"}
          >
            {coverSheet?.job_title}
          </Typography>
        )}

        <CommonGrid2
          display={"flex"}
          gap={lg ? "3rem" : "1rem"}
          alignItems={"center"}
          marginTop={lg ? "1rem" : "10px"}
        >
          {isLoading.loading ? (
            <Fragment>
              {Array.from({ length: 3 }).map((_, index) => (
                <HandleSkeletion
                  height={50}
                  width={lg ? "150px" : "60px"}
                  background="rgb(255 255 255 / 33%)"
                  transform={"scale(1)"}
                />
              ))}
            </Fragment>
          ) : (
            <Fragment>
              {headerData.map((item, index) => (
                <Fragment>
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"5px"}
                    alignItems={"start"}
                  >
                    <Typography
                      variant={lg ? "body4" : "h5xs"}
                      fontWeight={400}
                      color="#D5DADD"
                      textTransform={"capitalize"}
                      sx={{ whiteSpace: "pre" }}
                    >
                      {item.name}
                    </Typography>

                    <Typography
                      variant={lg ? "h2xs" : "body1xs"}
                      fontWeight={800}
                      textTransform={"capitalize"}
                    >
                      {item.content}
                    </Typography>
                  </CommonGrid2>
                  {index !== 2 && (
                    <CommonGrid2
                      padding={"2px"}
                      background="#2E2440"
                      borderRadius={"10px"}
                      height={"55px"}
                      // boxShadow={"0px 0px 1px 0px"}
                    />
                  )}
                </Fragment>
              ))}
            </Fragment>
          )}
        </CommonGrid2>
        {isLoading.loading ? (
          <HandleSkeletion
            height={40}
            width={lg ? "400px" : "100%"}
            background="rgb(255 255 255 / 33%)"
            margin={"10px auto 0px"}
            transform={"scale(1)"}
          />
        ) : (
          <Fragment>
            {!coverSheet?.submitted && (
              <Typography
                variant={lg ? "h5" : "h5xs"}
                color="#D5DADD"
                textAlign={"center"}
                fontWeight={500}
                backgroundColor="#402D66"
                width={"fit-content"}
                borderRadius={"10px"}
                padding={"7px 12px"}
                margin={"1rem 0px"}
              >
                Hi{" "}
                <CustomizeSpan color="#FA4F96" fontWeight={700}>
                  {coverSheet?.personal_details?.candidate_first_name}
                </CustomizeSpan>{" "}
                Are you interested in applying ?
              </Typography>
            )}
          </Fragment>
        )}

        <Fragment>
          {coverSheet?.submitted ? (
            <Fragment>
              {isLoading.loading ? (
                <HandleSkeletion
                  height={40}
                  width={lg ? "400px" : "100%"}
                  background="rgb(255 255 255 / 33%)"
                  margin={"10px auto 0px"}
                  transform={"scale(1)"}
                />
              ) : (
                <CommonGrid2
                  display={"flex"}
                  flexDirection={"column"}
                  gap="10px"
                  marginTop={"1.2rem"}
                >
                  <Typography
                    variant={lg ? "body4" : "subtitle1"}
                    fontWeight={800}
                  >
                    Status
                  </Typography>
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    alignItems={"center"}
                    height="100%"
                    gap="0.5rem"
                    padding={"0.8rem 1.5rem"}
                    backgroundColor={"#079455"}
                    borderRadius={"10px"}
                    width={"fit-content"}
                    margin={"auto"}
                  >
                    <CoverSheetTickIco />

                    <Typography
                      variant={lg ? "h5" : "subtitle3"}
                      fontWeight={600}
                      color="#FFFFFF"
                    >
                      Submission Successful
                    </Typography>
                  </Box>
                  <Typography
                    variant={lg ? "h6" : "p"}
                    fontWeight={600}
                    width={lg ? "80%" : "100%"}
                    margin={"auto"}
                    marginTop={"10px"}
                  >
                    {coverSheet.availability_status ===
                    "I am available and interested" ? (
                      <Fragment>
                        Thank You{" "}
                        <CustomizeSpan color="#FA4F96" fontWeight={700}>
                          {coverSheet?.personal_details?.candidate_first_name}.
                        </CustomizeSpan>{" "}
                        We will let you know the status through your email.
                      </Fragment>
                    ) : coverSheet.availability_status ===
                      "I am not available" ? (
                      <Fragment>
                        Thank You!{" "}
                        <CustomizeSpan color="#FA4F96" fontWeight={700}>
                          {coverSheet?.personal_details?.candidate_first_name}
                        </CustomizeSpan>{" "}
                        for letting us know
                      </Fragment>
                    ) : (
                      <Fragment>
                        No problem{" "}
                        <CustomizeSpan color="#FA4F96" fontWeight={700}>
                          {coverSheet?.personal_details?.candidate_first_name}
                        </CustomizeSpan>{" "}
                        . We’ll tailor future jobs to your preferences
                      </Fragment>
                    )}
                  </Typography>
                </CommonGrid2>
              )}
            </Fragment>
          ) : (
            <CommonGrid2
              display={"flex"}
              flexWrap={"wrap"}
              gap={"1.5rem"}
              justifyContent={"center"}
              alignItems={"center"}
              marginTop={lg ? "10px" : "1.5rem"}
              width={"100%"}
            >
              <CommonButton
                customStyle={{
                  minWidth: "150px",
                  maxWidth: "180px",
                  width: "100%",
                }}
                disabled={isLoading.loading}
                mobileFontSize="13px"
                variant="contained"
                fontWeight={700}
                background={"#fff"}
                color="#000"
                value={"Not Interested"}
                padding={"10px 1.5rem"}
                onClick={handleNotInterested}
              />
              <CommonButton
                mobileFontSize="13px"
                customStyle={{
                  minWidth: "150px",
                  maxWidth: "180px",
                  width: "100%",
                }}
                variant="outlined"
                fontWeight={700}
                background={"#fff"}
                color="#7F56D9"
                value={"Apply Now"}
                padding={"10px 1.5rem"}
                onClick={() => handleApply("apply")}
                disabled={isLoading.loading}
              />
              <CommonButton
                customStyle={{
                  minWidth: "150px",
                  maxWidth: "180px",
                  width: "100%",
                }}
                mobileFontSize="13px"
                fontWeight={700}
                value={"View Job Description"}
                padding={"10px 1.5rem"}
                onClick={handleViewJobDescription}
                disabled={isLoading.loading}
              />
            </CommonGrid2>
          )}
        </Fragment>

        {/* {isLoading.submission && (
          <CommonGrid2
            justifyContent={"center"}
            display={"flex"}
            marginTop={"1rem"}
          >
            <CommonGrid2
              width={"max-content"}
              justifyContent={"center"}
              display={"flex"}
              alignItems={"center"}
              gap="10px"
              background="#079455"
              padding={"10px"}
              borderRadius={"8px"}
            >
              <SubmissionTickIco />
              <Typography variant="h5" color="#fff">
                Submission Successful
              </Typography>
            </CommonGrid2>
          </CommonGrid2>
        )} */}
      </CommonGrid2>
    </CustomDiv>
  );
}
